import React from 'react';
import { Container, Typography, Grid } from '@material-ui/core';
import { useStyles, NewOfferLogic } from './newOffer.module';
import CardCurrentBalance from '../shared/cardCurrentBalance/cardCurrentBalance';
import CardOfferSelection from '../shared/cardOfferSelection/cardOfferSelection';
import Footer from '../footer/Footer';
import NotFound from '../notFound/NotFound';
import { useOfferType } from '../shared/cardOfferSelection/useQuery';
import { ExchangeLogic, WalletService } from '../exchange/exchange.module';
import { Link } from 'react-router-dom';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';

export default function NewOffers(props) {
  const classes = useStyles();
  const { isValid, type } = useOfferType();
  const service = WalletService();
  const { translator } = NewOfferLogic();

  const { values } = ExchangeLogic(props, service.getData);

  if (!isValid) {
    return <NotFound />;
  }
  return (
    <>
      <Container className={classes.container}>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <div className={classes.subtitleDashboard}>
              <Link to={"/exchange"} className={classes.link}>
                <KeyboardArrowLeftIcon
                className={classes.textSubtitleDashboard}
                />
              </Link>    
              <Typography className={classes.textSubtitleDashboard}>
                {translator('newOffers.title')}{' '}
              </Typography>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item lg={1} md={1} sm={1} xs={12}></Grid>
          <Grid item lg={10} md={10} sm={10} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <CardCurrentBalance
                  value={type === 'SELL' ? values.totalCoins : values.totalUSD}
                  available={
                    type === 'SELL'
                      ? values.availableCoins || 0
                      : values.availableUSD || 0
                  }
                  asset={type === 'SELL' ? 'EGRN' : 'USD'}
                />
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <CardOfferSelection
                  available={
                    type === 'SELL'
                      ? values.availableCoins || 0
                      : values.availableUSD || 0
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={1} md={1} sm={1} xs={12}></Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
}
